/* MasterMedi chatbot — markup is in snippets/chatbot.liquid, data in assets/chatbot-knowledge.json */
(function () {
  var root = document.getElementById('mmc');
  if (!root) return;

  var endpoint = root.dataset.endpoint;
  var knowledgeUrl = root.dataset.knowledge;
  var errorText = root.dataset.error;

  var win = root.querySelector('.mmc-window');
  var launcher = root.querySelector('.mmc-launcher');
  var closeBtn = root.querySelector('.mmc-close');
  var list = root.querySelector('.mmc-messages');
  var form = root.querySelector('.mmc-form');
  var input = root.querySelector('.mmc-input');
  var sendBtn = root.querySelector('.mmc-send');
  var teaser = root.querySelector('.mmc-teaser');
  var chips = root.querySelector('.mmc-chips');

  var busy = false;

  // Same random id for this tab across reloads, so the backend keeps one conversation. A new tab starts a new one.
  var token = null;
  try {
    token = sessionStorage.getItem('mmc_session');
    if (!token) {
      token = crypto.randomUUID();
      sessionStorage.setItem('mmc_session', token);
    }
  } catch (e) {
    token = token || crypto.randomUUID();
  }

  // Chat history for this tab: survives a refresh, cleared when the tab is closed.
  var HISTORY_KEY = 'mmc_history';
  var OPEN_KEY = 'mmc_open';
  function loadHistory() {
    try { return JSON.parse(sessionStorage.getItem(HISTORY_KEY)) || []; } catch (e) { return []; }
  }
  function record(type, text) {
    try {
      var history = loadHistory();
      history.push({ type: type, text: text });
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch (e) {}
  }
  function rememberOpen(value) {
    try { sessionStorage.setItem(OPEN_KEY, value ? '1' : '0'); } catch (e) {}
  }

  // Remove empty values so unfilled fields in the JSON are never sent to the AI.
  function clean(value) {
    if (Array.isArray(value)) {
      var arr = value.map(clean).filter(function (v) { return v !== undefined; });
      return arr.length ? arr : undefined;
    }
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (k) {
        var v = clean(value[k]);
        if (v !== undefined) out[k] = v;
      });
      return Object.keys(out).length ? out : undefined;
    }
    if (typeof value === 'string') return value.trim() ? value.trim() : undefined;
    return value === null ? undefined : value;
  }

  // Loaded once. If the file is missing or broken, chat still works without it.
  var knowledgePromise = null;
  function getKnowledge() {
    if (!knowledgePromise) {
      knowledgePromise = fetch(knowledgeUrl)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { return clean(data) || null; })
        .catch(function () { return null; });
    }
    return knowledgePromise;
  }

  // Bot text supports **bold**, links, emails and simple markdown tables. Built with DOM nodes, never innerHTML.
  var inlineRe = /\*\*(.+?)\*\*|(https?:\/\/[^\s<]+[^\s<.,:;!?)\]])|([\w.+-]+@[\w-]+\.[\w.-]*\w)/g;
  function appendInline(parent, text) {
    var re = new RegExp(inlineRe.source, 'g');
    var last = 0;
    var m;
    while ((m = re.exec(text))) {
      if (m.index > last) parent.appendChild(document.createTextNode(text.slice(last, m.index)));
      var node;
      if (m[1] != null) {
        node = document.createElement('strong');
        appendInline(node, m[1]);
      } else {
        node = document.createElement('a');
        node.href = m[2] || 'mailto:' + m[3];
        node.textContent = m[2] || m[3];
        if (m[2]) { node.target = '_blank'; node.rel = 'noopener'; }
      }
      parent.appendChild(node);
      last = re.lastIndex;
    }
    if (last < text.length) parent.appendChild(document.createTextNode(text.slice(last)));
  }

  function tableCells(line) {
    return line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(function (c) { return c.trim(); });
  }

  function isSeparator(line) {
    return /-/.test(line) && /^[\s|:-]+$/.test(line);
  }

  function buildTable(lines) {
    var table = document.createElement('table');
    table.className = 'mmc-table';
    var rows = lines.filter(function (l) { return !isSeparator(l); }).map(tableCells);
    // A header row of empty cells ("| | |") is skipped, so the table becomes label/value rows.
    rows.forEach(function (cells, i) {
      var isHead = i === 0 && lines.length > 1 && isSeparator(lines[1]);
      if (isHead && cells.every(function (c) { return !c; })) return;
      var tr = document.createElement('tr');
      cells.forEach(function (c) {
        var cell = document.createElement(isHead ? 'th' : 'td');
        appendInline(cell, c);
        tr.appendChild(cell);
      });
      (isHead ? (table.tHead || table.createTHead()) : (table.tBodies[0] || table.appendChild(document.createElement('tbody')))).appendChild(tr);
    });
    var wrap = document.createElement('div');
    wrap.className = 'mmc-table-wrap';
    wrap.appendChild(table);
    return wrap;
  }

  function renderRich(parent, text) {
    var lines = text.split('\n');
    var buffer = [];
    function flushText() {
      if (!buffer.length) return;
      var chunk = buffer.join('\n').replace(/^\n+|\n+$/g, '');
      buffer = [];
      if (!chunk) return;
      var p = document.createElement('div');
      p.className = 'mmc-text';
      appendInline(p, chunk);
      parent.appendChild(p);
    }
    for (var i = 0; i < lines.length; i++) {
      if (/^\s*\|.*\|\s*$/.test(lines[i])) {
        var block = [];
        while (i < lines.length && /^\s*\|.*\|\s*$/.test(lines[i])) block.push(lines[i++]);
        i--;
        flushText();
        parent.appendChild(buildTable(block));
        parent.classList.add('mmc-msg--wide');
      } else {
        buffer.push(lines[i]);
      }
    }
    flushText();
  }

  function addMessage(text, type) {
    var el = document.createElement('div');
    el.className = 'mmc-msg mmc-msg--' + type;
    if (type === 'bot') renderRich(el, text);
    else el.textContent = text;
    list.appendChild(el);
    list.scrollTop = list.scrollHeight;
    return el;
  }

  // Product cards. The AI replies with product URLs; we turn them into cards using Shopify's /products/<handle>.js.
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productUrlRe = /https?:\/\/(?:www\.)?mastermedi\.co\/products\/([a-z0-9-]+)[^\s)\]]*/gi;
  var productCache = {};
  var MAX_CARDS = 6;

  function fetchProductJson(handle) {
    return fetch(shopRoot + 'products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetchProductJson(handle).then(function (product) {
        if (product) return product;
        // Handle was renamed: the product page redirects to the new handle, but the .js endpoint doesn't.
        return fetch(shopRoot + 'products/' + handle, { method: 'HEAD' })
          .then(function (res) {
            var m = res.ok && /\/products\/([^/?#]+)/.exec(res.url);
            return m && m[1] !== handle ? fetchProductJson(m[1]) : null;
          })
          .catch(function () { return null; });
      });
    }
    return productCache[handle];
  }

  function findHandles(text) {
    var handles = [];
    text.replace(productUrlRe, function (url, handle) {
      handle = handle.toLowerCase();
      if (handles.indexOf(handle) === -1 && handles.length < MAX_CARDS) handles.push(handle);
    });
    return handles;
  }

  // Remove links for products shown as cards, plus leftover "Link:" labels and markdown.
  function stripProductLinks(text, shown) {
    function isShown(url) {
      var m = /\/products\/([a-z0-9-]+)/i.exec(url);
      return m && shown.indexOf(m[1].toLowerCase()) !== -1;
    }
    return text
      .replace(/\[([^\]]+)\]\((https?:[^)\s]+)\)/g, function (all, label, url) {
        return isShown(url) ? label : all;
      })
      .replace(/[ \t]*(?:[-\u2013\u2014|:]\s*)?(?:(?:product\s+)?(?:link|url)\s*:?\s*)?\(?(https?:\/\/[^\s()]+?)\)?(?=[.,]?(?:\s|$))/gi, function (all, url) {
        return isShown(url) ? '' : all;
      })
      .replace(/^[ \t]*[-*\u2022]?[ \t]*$/gm, '')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function imageUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function addToCart(variantId, button) {
    button.disabled = true;
    button.textContent = 'Adding\u2026';
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        button.textContent = 'Added \u2713';
        button.classList.add('is-added');
        // Lets the theme refresh the cart count / drawer.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Try again';
      });
  }

  function buildCard(product) {
    var url = shopRoot + 'products/' + product.handle;
    var variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var card = el('div', 'mmc-card');

    var media = el('a', 'mmc-card__media');
    media.href = url;
    if (product.featured_image) {
      var img = el('img');
      img.src = imageUrl(product.featured_image, 300);
      img.alt = product.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    card.appendChild(media);

    var body = el('div', 'mmc-card__body');
    var title = el('a', 'mmc-card__title', product.title);
    title.href = url;
    body.appendChild(title);

    var price = el('div', 'mmc-card__price', formatMoney(variant ? variant.price : product.price));
    if (variant && variant.compare_at_price > variant.price) {
      price.appendChild(el('s', 'mmc-card__compare', formatMoney(variant.compare_at_price)));
    }
    body.appendChild(price);

    var actions = el('div', 'mmc-card__actions');
    if (product.available && product.variants.length === 1) {
      var add = el('button', 'mmc-card__btn mmc-card__btn--primary', 'Add to cart');
      add.type = 'button';
      add.addEventListener('click', function () { addToCart(variant.id, add); });
      actions.appendChild(add);
    } else if (!product.available) {
      actions.appendChild(el('span', 'mmc-card__soldout', 'Sold out'));
    }
    var view = el('a', 'mmc-card__btn', product.variants.length > 1 && product.available ? 'Choose options' : 'View');
    view.href = url;
    actions.appendChild(view);
    body.appendChild(actions);

    card.appendChild(body);
    return card;
  }

  // Long replies: scroll so the start of the reply is visible instead of jumping to the very end.
  function scrollToReply(node) {
    if (!node) return;
    var top = node.offsetTop - list.offsetTop - 12;
    list.scrollTop = Math.min(list.scrollHeight, top);
  }

  // Newsletter signup. The bot puts [[EMAIL_SIGNUP]] in a reply (e.g. "any other discount?") and we show an email box
  // that posts to the theme's newsletter form (snippets/chatbot.liquid), so the customer becomes a subscriber.
  var signupMarkRe = /\[\[\s*EMAIL_SIGNUP\s*\]\]/gi;
  var SUBSCRIBED_KEY = 'mmc_subscribed';
  function isSubscribed() {
    try { return localStorage.getItem(SUBSCRIBED_KEY) === '1'; } catch (e) { return false; }
  }

  function addSignup() {
    if (isSubscribed()) {
      var already = "You're already on our list ✅ We'll email you as soon as a new discount goes live!";
      addMessage(already, 'bot');
      record('bot', already);
      return;
    }
    var shopForm = root.querySelector('.mmc-signup-form');
    if (!shopForm) return;

    var box = el('form', 'mmc-signup');
    box.noValidate = true;
    var field = el('input', 'mmc-signup__input');
    field.type = 'email';
    field.required = true;
    field.placeholder = 'you@example.com';
    field.autocomplete = 'email';
    field.setAttribute('aria-label', 'Your email');
    var btn = el('button', 'mmc-signup__btn', 'Notify me');
    btn.type = 'submit';
    var note = el('div', 'mmc-signup__note');
    note.setAttribute('role', 'status');
    box.appendChild(field);
    box.appendChild(btn);
    box.appendChild(note);
    list.appendChild(box);
    list.scrollTop = list.scrollHeight;

    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = field.value.trim();
      if (!email || !field.checkValidity()) {
        note.textContent = 'Please enter a valid email address.';
        field.focus();
        return;
      }
      note.textContent = '';
      btn.disabled = true;
      btn.textContent = 'Saving…';
      shopForm.querySelector('[name="contact[email]"]').value = email;

      fetch(shopForm.action, { method: 'POST', body: new FormData(shopForm), credentials: 'same-origin' })
        .then(function (res) {
          // Shopify sometimes asks for a captcha: fall back to a normal submit so the customer can complete it.
          if (/\/challenge/.test(res.url)) {
            shopForm.submit();
            return;
          }
          return res.text().then(function (html) {
            // The returned page renders snippets/chatbot.liquid again, which marks the result of this form.
            var page = new DOMParser().parseFromString(html, 'text/html');
            var result = page.querySelector('#mmc [data-mmc-signup]');
            var ok = /customer_posted=true/.test(res.url) || (result && result.dataset.mmcSignup === 'ok');
            if (!ok) {
              var reason = result && result.textContent.trim();
              console.warn('[chatbot] newsletter signup failed', res.status, res.url, reason || '(no form result in page)');
              throw new Error(reason || 'Signup failed');
            }
            try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (err) {}
            box.remove();
            var done = "🎉 You're in! We'll email **" + email + '** as soon as a new discount drops. Meanwhile, your **10% first-order discount** is waiting at checkout 😉';
            addMessage(done, 'bot');
            record('bot', done);
          });
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Notify me';
          note.textContent = err && err.message !== 'Signup failed' && err.message !== 'Failed to fetch'
            ? err.message
            : "Couldn't sign you up. Please check the email and try again.";
        });
    });
  }

  // Shows the reply text, then a swipeable row of product cards for any products it links to.
  function addBotReply(text) {
    var wantsSignup = text.search(signupMarkRe) !== -1;
    if (wantsSignup) {
      text = text.replace(signupMarkRe, '').replace(/\n{3,}/g, '\n\n').trim();
      return (text ? addProductReply(text) : Promise.resolve()).then(addSignup);
    }
    return addProductReply(text);
  }

  function addProductReply(text) {
    var handles = findHandles(text);
    if (!handles.length) return Promise.resolve(scrollToReply(addMessage(text, 'bot')));

    return Promise.all(handles.map(loadProduct)).then(function (results) {
      // Match by the handle in the reply's URL, which may be an old handle that redirected.
      var shown = handles.filter(function (h, i) { return results[i]; });
      var products = results.filter(Boolean);
      var cleaned = stripProductLinks(text, shown);
      var msg = cleaned ? addMessage(cleaned, 'bot') : null;
      if (products.length) {
        var row = el('div', 'mmc-cards');
        products.forEach(function (p) { row.appendChild(buildCard(p)); });
        list.appendChild(row);
      }
      scrollToReply(msg || row);
    });
  }

  // Phones: keep the full-screen chat sized to the area above the keyboard, so the input never hides behind it.
  var mobileQuery = window.matchMedia('(max-width: 640px)');
  function isMobile() {
    return mobileQuery.matches;
  }
  function fitToViewport() {
    var vv = window.visualViewport;
    if (!vv || !isMobile() || !isOpen()) {
      win.style.removeProperty('height');
      win.style.removeProperty('top');
      return;
    }
    var atBottom = list.scrollHeight - list.scrollTop - list.clientHeight < 40;
    win.style.height = vv.height + 'px';
    win.style.top = vv.offsetTop + 'px';
    if (atBottom) list.scrollTop = list.scrollHeight;
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitToViewport);
    window.visualViewport.addEventListener('scroll', fitToViewport);
  }
  input.addEventListener('focus', function () {
    // iOS scrolls the page when the keyboard opens; re-fit once it settles.
    setTimeout(fitToViewport, 50);
    setTimeout(fitToViewport, 350);
  });

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function open() {
    hideTeaser(true);
    root.classList.add('is-open');
    rememberOpen(true);
    win.setAttribute('aria-hidden', 'false');
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('aria-label', 'Close chat');
    if (isMobile()) {
      // On phones the keyboard only opens when the customer taps the input, so they see the welcome and suggestions first.
      document.documentElement.classList.add('mmc-lock');
      fitToViewport();
    } else {
      // Wait for the open animation before focusing.
      setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    }
    list.scrollTop = list.scrollHeight;
    getKnowledge();
  }

  function close() {
    root.classList.remove('is-open');
    rememberOpen(false);
    document.documentElement.classList.remove('mmc-lock');
    input.blur();
    win.setAttribute('aria-hidden', 'true');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-label', 'Open chat');
    launcher.focus({ preventScroll: true });
  }

  // Suggested questions disappear after the first message.
  function hideChips() {
    if (!chips || !chips.parentNode) return;
    chips.classList.add('is-leaving');
    var node = chips;
    chips = null;
    setTimeout(function () { node.remove(); }, 250);
  }

  // Greeting cloud next to the icon. Once dismissed or the chat is opened, it stays hidden for this visit.
  var TEASER_KEY = 'mmc_teaser_done';
  function teaserDone() {
    try { return sessionStorage.getItem(TEASER_KEY) === '1'; } catch (e) { return false; }
  }
  function hideTeaser(remember) {
    root.classList.remove('is-teasing');
    if (!remember) return;
    try { sessionStorage.setItem(TEASER_KEY, '1'); } catch (e) {}
  }
  if (teaser && root.dataset.teaserDelay != null) {
    var inEditor = window.Shopify && Shopify.designMode;
    if (inEditor || !teaserDone()) {
      setTimeout(function () {
        if (!isOpen()) root.classList.add('is-teasing');
      }, inEditor ? 300 : parseFloat(root.dataset.teaserDelay) * 1000);
    }
    teaser.querySelector('.mmc-teaser__body').addEventListener('click', open);
    teaser.querySelector('.mmc-teaser__close').addEventListener('click', function (e) {
      e.stopPropagation();
      hideTeaser(true);
    });
  }

  if (chips) {
    chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.mmc-chip');
      if (chip) send(chip.textContent);
    });
  }

  // Approved answers for common questions (quick_answers in the knowledge file) show instantly, no AI call.
  function normalize(text) {
    return text.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function findQuickAnswer(knowledge, text) {
    var key = normalize(text);
    var items = (knowledge && knowledge.quick_answers) || [];
    for (var i = 0; i < items.length; i++) {
      var qs = items[i].questions || [];
      for (var j = 0; j < qs.length; j++) {
        if (normalize(qs[j]) === key) return items[i].answer;
      }
    }
    return null;
  }
  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function send(text) {
    text = text.trim();
    if (!text || busy) return;

    busy = true;
    sendBtn.disabled = true;
    addMessage(text, 'user');
    record('user', text);
    input.value = '';
    hideChips();
    var typing = addMessage('', 'bot mmc-msg--typing');
    typing.setAttribute('aria-label', 'Typing');
    typing.innerHTML = '<span></span><span></span><span></span>';

    getKnowledge()
      .then(function (knowledge) {
        var quick = findQuickAnswer(knowledge, text);
        // Short "typing" pause so the instant answer still feels like a chat.
        if (quick) return wait(700 + Math.min(quick.length, 800)).then(function () { return { reply: quick }; });

        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: text, sessionToken: token, knowledge: knowledge })
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || !data.reply) throw new Error('Bad response');
            return data;
          });
        });
      })
      .then(function (data) {
        // The signup box is not saved: after a refresh only the reply text comes back.
        record('bot', data.reply.replace(signupMarkRe, '').replace(/\n{3,}/g, '\n\n').trim());
        return addBotReply(data.reply).then(function () { typing.remove(); });
      })
      .catch(function () {
        typing.remove();
        addMessage(errorText, 'error');
      })
      .then(function () {
        busy = false;
        sendBtn.disabled = false;
        // On phones keep the keyboard as it is: it would cover a fresh reply if we opened it here.
        if (!isMobile()) input.focus({ preventScroll: true });
      });
  }

  // Rebuild the conversation after a refresh, in order (product cards load async), then reopen if it was open.
  var saved = loadHistory();
  if (saved.length) {
    if (chips) { chips.remove(); chips = null; }
    hideTeaser(true);
    saved.reduce(function (chain, item) {
      return chain.then(function () {
        if (item.type === 'user') return addMessage(item.text, 'user');
        return item.text ? addProductReply(item.text) : null;
      });
    }, Promise.resolve()).then(function () {
      list.scrollTop = list.scrollHeight;
    });
  }
  try {
    if (sessionStorage.getItem(OPEN_KEY) === '1') open();
  } catch (e) {}

  // Sticky bars fixed to the bottom of the screen (PDP "Add to cart" etc.): while one is showing, the bot moves above it.
  var BOTTOM_BARS = '.product-quick-add';
  var liftQueued = false;
  var currentLift = -1;
  function updateLift() {
    liftQueued = false;
    var lift = 0;
    var vh = window.innerHeight;
    document.querySelectorAll(BOTTOM_BARS).forEach(function (bar) {
      var style = getComputedStyle(bar);
      if (style.visibility === 'hidden' || style.display === 'none' || parseFloat(style.opacity) === 0) return;
      var rect = bar.getBoundingClientRect();
      // Only bars that actually sit at the bottom edge and overlap the bot's side of the screen.
      if (!rect.height || rect.bottom < vh - 40 || rect.top >= vh) return;
      var launcherRect = launcher.getBoundingClientRect();
      if (rect.right < launcherRect.left || rect.left > launcherRect.right) return;
      lift = Math.max(lift, vh - rect.top);
    });
    lift = Math.round(lift);
    if (lift === currentLift) return;
    currentLift = lift;
    root.style.setProperty('--mmc-lift', lift + 'px');
  }
  function queueLift() {
    if (liftQueued) return;
    liftQueued = true;
    requestAnimationFrame(updateLift);
  }
  var bars = document.querySelectorAll(BOTTOM_BARS);
  if (bars.length) {
    // Re-check after the bar's show/hide transition too.
    var barObserver = new MutationObserver(function () { queueLift(); setTimeout(queueLift, 200); });
    bars.forEach(function (bar) {
      barObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    });
    window.addEventListener('scroll', queueLift, { passive: true });
    window.addEventListener('resize', queueLift);
    queueLift();
  }

  launcher.addEventListener('click', function () {
    isOpen() ? close() : open();
  });
  closeBtn.addEventListener('click', close);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    send(input.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });
})();
